import IPlanningEntryService from "@/services/IPlanningEntryService";
import PlanningEntryListFilter from "@/models/planningEntry/PlanningEntryListFilter";
import AsiListTableOptions from "@/components/common/AsiListTableOptions";
import PaginatedResponse from "@/models/PaginatedResponse";
import PlanningEntryListEntry from "@/models/planningEntry/PlanningEntryListEntry";
import Vue from "vue";
import PlanningEntryUpdate from "@/models/planningEntry/PlanningEntryUpdate";

export default class AxiosPlanningEntryService implements IPlanningEntryService {

	public planningEntries(filter: PlanningEntryListFilter | null, options: AsiListTableOptions | null): Promise<PaginatedResponse<PlanningEntryListEntry>> {
		return Vue.$axios.get<PaginatedResponse<PlanningEntryListEntry>>('/planning-entry', {
			params: {
				...filter,
				...options
			}
		})
			.then(res => res.data);
	}

	public update(id: string, model: PlanningEntryUpdate): Promise<null> {
		return Vue.$axios.patch(`/planning-entry/${id}`, model).then(res => res.data);
	}

	public delete(id: string): Promise<null> {
		return Vue.$axios.delete(`/planning-entry/${id}`).then(res => res.data);
	}

}
